import { render, staticRenderFns } from "./group-autocomplete.vue?vue&type=template&id=28e5be84&"
import script from "./group-autocomplete.vue?vue&type=script&lang=js&"
export * from "./group-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports